import { AxiosError, isAxiosError } from 'axios'
import { httpClient } from 'shared/lib/httpClient'
import {
   CustomerContactPayload,
   CustomerContactType,
   FetchVehicleType,
   VehicleType,
} from 'shared/store/useCustomers/types'
import consoleMessage from 'shared/utils/helpers/consoleMessage'

export function getBrandsService(customerUuid: string) {
   let errMessage = ''

   return httpClient
      .get<string[]>(`clients/${customerUuid}/vehicles/brands`)
      .then((res) => ({
         status: res.status,
         data: res.data,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS getBrands service', errMessage, 'error')
         throw error
      })
}
export function getModelsService(customerUuid: string, brand: string) {
   let errMessage = ''

   return httpClient
      .get<string[]>(`clients/${customerUuid}/vehicles/models?brand=${brand}`)
      .then((res) => ({
         status: res.status,
         data: res.data,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS getBrands service', errMessage, 'error')
         throw error
      })
}
export function getTrimsService(customerUuid: string, brand: string, model: string, year?: string) {
   let errMessage = ''

   const url = year
      ? `clients/${customerUuid}/vehicles/trims?brand=${brand}&model=${model}&year=${year}`
      : `clients/${customerUuid}/vehicles/trims?brand=${brand}&model=${model}`

   return httpClient
      .get<string[]>(url)
      .then((res) => ({
         status: res.status,
         data: res.data,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS getBrands service', errMessage, 'error')
         throw error
      })
}

export function getCustomersVehiclesService(customerUuid: string) {
   let errMessage = ''

   return httpClient
      .get<FetchVehicleType[]>(`clients/${customerUuid}/vehicles`)
      .then((res) => ({
         status: res.status,
         data: res.data,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS getBrands service', errMessage, 'error')
         throw error
      })
}

export function addVehicleToCustomerService(customerUuid: string, payload: VehicleType) {
   let errMessage

   return httpClient
      .post<Result>(`clients/${customerUuid}/vehicles`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS addVehicleToCustomer service', errMessage, 'error')
         throw error
      })
}

export function editVehicleService(customerUuid: string, vehicleUuid: string, payload: VehicleType) {
   let errMessage

   return httpClient
      .put<Result>(`clients/${customerUuid}/vehicles/${vehicleUuid}`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS editVehicle service', errMessage, 'error')
         throw error
      })
}

export function deleteVehicleService(customerUuid: string, vehicleUuid: string) {
   let errMessage

   return httpClient
      .delete<Result>(`clients/${customerUuid}/vehicles/${vehicleUuid}`)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS deleteVehicle service', errMessage, 'error')
         throw error
      })
}

export function addContactToCustomerService(customerUuid: string, payload: CustomerContactPayload) {
   let errMessage

   return httpClient
      .post<Result>(`clients/${customerUuid}/contacts`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS addVehicleToCustomer service', errMessage, 'error')
         throw error
      })
}

export function editContactService(customerUuid: string, contactUuid: string, payload: CustomerContactType) {
   let errMessage

   return httpClient
      .patch<Result>(`clients/${customerUuid}/contacts/${contactUuid}`, payload)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS editVehicle service', errMessage, 'error')
         throw error
      })
}

export function deleteContactService(customerUuid: string, contactUuid: string) {
   let errMessage

   return httpClient
      .delete<Result>(`clients/${customerUuid}/contacts/${contactUuid}`)
      .then((res) => ({
         status: res.status,
      }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('CUSTOMERS deleteVehicle service', errMessage, 'error')
         throw error
      })
}
